import { createApp } from 'vue'
import router from './router/index'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'vant/es/toast/style';
import 'vant/es/notify/style';
import 'vant/es/dialog/style';
const app = createApp(App)
app.use(router)
app.use(ElementPlus)
app.mount('#app')
